<template>
  <v-container v-if="loading">
    <v-row>
      <v-col class="mt-10">
        <div class="text-center">
          <v-progress-circular
            indeterminate
            :size="200"
            :width="15"
            color="blue lighten-1"
          ></v-progress-circular>
        </div>
      </v-col>
    </v-row>
  </v-container>
  <v-container fluid v-else>
    <v-row class="justify-space-between">
      <v-col cols="2"><h2>Создать КП</h2></v-col>
      <v-col cols="3" class="d-flex justify-end">
        <v-btn
          @click="addToDeal"
          class="mr-2 rounded-lg"
          outlined
          color="#6C86E252"
          ><v-icon color="#000">mdi-tray-arrow-up</v-icon>
          <h4 style="color: #000">Создание КП</h4></v-btn
        >
        <v-menu
          transition="slide-x-transition"
          bottom
          right
          offset-y
          v-model="settings"
          :close-on-content-click="false"
          class="rounded-lg"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="rounded-lg"
              outlined
              color="#6C86E252"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="#000">mdi-cog</v-icon>
            </v-btn>
          </template>
          <v-card class="rounded-lg">
            <v-list class="rounded-lg">
              <v-list-item v-for="(item, i) in selectFields" :key="i">
                <v-checkbox
                  v-model="item.isTrue"
                  :label="item.title"
                  color="#419BEC"
                  :value="item.isTrue"
                  hide-details
                ></v-checkbox>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </v-col>
    </v-row>
    <v-row class="justify-space-between">
      <v-col cols="8">
        <v-chip
          dark
          color="#419BEC"
          class="rounded-lg mr-4 mb-2"
          elevation="1"
          style="height: 50px"
        >
          Общее кол-во щитов:&nbsp; <b> {{ total.quantityShields }}</b>
        </v-chip>
        <v-chip
          dark
          color="#419BEC"
          class="rounded-lg mr-4 mb-2"
          elevation="1"
          style="height: 50px"
        >
          Общая площадь(М²):&nbsp; <b>{{ total.s.toFixed(2) }}</b>
        </v-chip>
        <v-chip
          dark
          color="#419BEC"
          class="rounded-lg mr-4 mb-2"
          elevation="1"
          style="height: 50px"
        >
          Стоимость 1М² с учетом комлектующих:&nbsp;
          <b>{{
            new Intl.NumberFormat("ru-RU", {
              minimumFractionDigits: 2,
            }).format(
              (Number(total.priceRentMonth) / Number(total.s)).toFixed(2)
            )
          }}</b>
        </v-chip>
        <v-chip
          dark
          color="#419BEC"
          class="rounded-lg mr-4 mb-2"
          elevation="1"
          style="height: 50px"
        >
          Стоимость за 1 сутки 1 кв м:&nbsp;
          <b>{{
            new Intl.NumberFormat("ru-RU", {
              minimumFractionDigits: 2,
            }).format((entity / 30).toFixed(2))
          }}</b>
        </v-chip>
        <v-chip
          dark
          color="#419BEC"
          class="rounded-lg mr-4 mb-2"
          elevation="1"
          style="height: 50px"
        >
          Вес(кг):&nbsp; <b>{{ total.allWeight }}</b>
        </v-chip>
        <v-chip
          color="#8BC34A"
          class="rounded-lg mr-4 mb-2"
          elevation="1"
          style="height: 50px"
          ><b>
            Маржа(Руб.):&nbsp;
            {{
              new Intl.NumberFormat("ru-RU", {
                minimumFractionDigits: 2,
              }).format((total.priceAll - total.total).toFixed(0))
            }}</b
          >
        </v-chip>
      </v-col>
      <v-col class="d-flex justify-end">
        <v-chip
          color="#419BEC"
          class="rounded-lg mr-4 mb-2"
          elevation="1"
          style="height: 50px; width: 270px; color: white"
          >Стоимость за кв.м в мес.:&nbsp;
          <v-text-field
            class="pa-0 text-black"
            background-color="white"
            color="white"
            v-model="entity"
            dense
            outlined
            hide-details
            type="number"
            @input="getTotal"
          ></v-text-field>
        </v-chip>
        <v-chip
          label
          dark
          color="#EBF4FF"
          elevation="1"
          class="rounded-lg mr-4 mb-2"
          style="height: 50px"
        >
          <v-checkbox v-model="nds" color="#419BEC">
            <template #label>
              <b style="color: #419bec">с НДС</b>
            </template>
          </v-checkbox>
        </v-chip>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-simple-table>
          <thead>
            <tr>
              <th
                style="
                  border: 4px solid #e0e0e0;
                  border-right: 4px solid white;
                  background-color: #e0e0e0;
                "
                class="text-center"
                v-show="selectFields[0].isTrue"
              >
                N
              </th>
              <th
                style="
                  border: 4px solid #e0e0e0;
                  border-right: 4px solid white;
                  background-color: #e0e0e0;
                "
                class="text-center"
                v-show="selectFields[1].isTrue"
              >
                Артикул
              </th>
              <th
                style="
                  border: 4px solid #e0e0e0;
                  border-right: 4px solid white;
                  background-color: #e0e0e0;
                "
                class="text-center"
                v-show="selectFields[2].isTrue"
              >
                Наименование
              </th>
              <th
                style="
                  border: 4px solid #e0e0e0;
                  border-right: 4px solid white;
                  background-color: #e0e0e0;
                "
                class="text-center"
                v-show="selectFields[3].isTrue"
              >
                Площадь ед.
              </th>
              <th
                style="
                  border: 4px solid #e0e0e0;
                  border-right: 4px solid white;
                  background-color: #e0e0e0;
                "
                class="text-center"
                v-show="selectFields[4].isTrue"
              >
                Вес ед.
              </th>
              <th
                style="
                  border: 4px solid #e0e0e0;
                  border-right: 4px solid white;
                  background-color: #e0e0e0;
                "
                class="text-center"
                v-show="selectFields[5].isTrue"
              >
                Общий вес
              </th>
              <th
                style="
                  border: 4px solid #e0e0e0;
                  border-right: 4px solid white;
                  background-color: #e0e0e0;
                "
                class="text-center"
                v-show="selectFields[6].isTrue"
              >
                Кол-во, шт.
              </th>
              <th
                style="
                  border: 4px solid #e0e0e0;
                  border-right: 4px solid white;
                  background-color: #e0e0e0;
                "
                class="text-center"
                v-show="selectFields[7].isTrue"
              >
                S
              </th>
              <th
                style="
                  border: 4px solid #e0e0e0;
                  border-right: 4px solid white;
                  background-color: #e0e0e0;
                "
                class="text-center"
                v-show="selectFields[8].isTrue"
              >
                Себестоимость
              </th>
              <th
                style="
                  border: 4px solid #e0e0e0;
                  border-right: 4px solid white;
                  background-color: #e0e0e0;
                "
                class="text-center"
                v-show="selectFields[9].isTrue"
              >
                Итого
              </th>
              <th
                style="
                  border: 4px solid #e0e0e0;
                  border-right: 4px solid white;
                  background-color: #e0e0e0;
                "
                class="text-center"
                v-show="selectFields[10].isTrue"
              >
                Стоимость руб. (шт.)
              </th>
              <th
                style="
                  border: 4px solid #e0e0e0;
                  border-right: 4px solid white;
                  background-color: #e0e0e0;
                "
                class="text-center"
                v-show="selectFields[11].isTrue"
              >
                Стоимость руб.(общая)
              </th>
              <th
                style="
                  border: 4px solid #e0e0e0;
                  border-right: 4px solid white;
                  background-color: #e0e0e0;
                "
                class="text-center"
                v-show="selectFields[12].isTrue"
              >
                Стоимость аренды ед. в сутки, руб
              </th>
              <th
                style="
                  border: 4px solid #e0e0e0;
                  border-right: 4px solid white;
                  background-color: #e0e0e0;
                "
                class="text-center"
                v-show="selectFields[13].isTrue"
              >
                Аренда комплекта в сутки, руб.
              </th>
              <th
                style="
                  border: 4px solid #e0e0e0;
                  border-right: 4px solid white;
                  background-color: #e0e0e0;
                "
                class="text-center"
                v-show="selectFields[14].isTrue"
              >
                Кол-во дней
              </th>
              <th
                style="
                  border: 4px solid #e0e0e0;
                  border-right: 4px solid white;
                  background-color: #e0e0e0;
                "
                class="text-center"
                v-show="selectFields[15].isTrue"
              >
                Стоимость аренды в месяц, руб.
              </th>
              <th
                style="
                  border: 4px solid #e0e0e0;
                  border-right: 4px solid white;
                  background-color: #e0e0e0;
                "
                class="text-center"
                v-show="selectFields[16].isTrue"
              >
                %
              </th>
              <th style="background-color: #e0e0e0" class="text-center">
                Удалить
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in tableData"
              :key="`${item.id}/ ${index}`"
            >
              <td class="text-center pa-0 pr-1" v-show="selectFields[0].isTrue">
                <v-text-field
                  class="pa-0 mt-2"
                  v-model="item.h"
                  dense
                  hide-details
                  outlined
                  style="min-width: 60px"
                ></v-text-field>
              </td>
              <td
                class="text-center pa-0 pl-0 pr-1"
                v-show="selectFields[1].isTrue"
              >
                <v-text-field
                  class="pa-0 mt-2"
                  style="min-width: 100px"
                  v-model="item.articl"
                  outlined
                  hide-details
                  dense
                ></v-text-field>
              </td>
              <td
                v-show="selectFields[2].isTrue"
                class="text-center pa-0 pl-0 pr-1"
              >
                <v-autocomplete
                  @input="selectProducts(item)"
                  class="pa-0 mt-2"
                  v-model="item.productID"
                  style="min-width: 250px"
                  dense
                  hide-details
                  outlined
                  :items="products"
                  item-value="id"
                  item-text="name"
                >
                </v-autocomplete>
              </td>
              <td
                v-show="selectFields[3].isTrue"
                class="text-left pa-0 pl-0 pr-1"
              >
                <v-text-field
                  class="pa-0 mt-2 centerTextField"
                  style="min-width: 60px"
                  v-model="item.square"
                  dense
                  hide-details
                  outlined
                  type="number"
                  @input="getTotal"
                ></v-text-field>
              </td>
              <td
                v-show="selectFields[4].isTrue"
                class="text-left pa-0 pl-0 pr-1"
              >
                <v-text-field
                  class="pa-0 mt-2 centerTextField"
                  style="min-width: 60px"
                  v-model="item.weight"
                  dense
                  hide-details
                  outlined
                  type="number"
                  @input="setWeight(item)"
                ></v-text-field>
              </td>
              <td
                v-show="selectFields[5].isTrue"
                class="text-left pa-0 pl-0 pr-1"
              >
                <v-text-field
                  class="pa-0 mt-2 centerTextField"
                  style="min-width: 60px"
                  v-model="item.allWeight"
                  dense
                  hide-details
                  outlined
                  type="number"
                  @input="getTotal"
                ></v-text-field>
              </td>
              <td
                v-show="selectFields[6].isTrue"
                class="text-left pa-0 pl-0 pr-1"
              >
                <v-text-field
                  class="pa-0 mt-2 centerTextField"
                  style="min-width: 60px"
                  v-model="item.quantity"
                  dense
                  hide-details
                  outlined
                  type="number"
                  @input="setQuantity(item)"
                ></v-text-field>
              </td>
              <td
                v-show="selectFields[7].isTrue"
                class="text-left pa-0 pl-0 pr-1"
              >
                <v-text-field
                  class="pa-0 mt-2 centerTextField"
                  v-model="item.s"
                  dense
                  hide-details
                  outlined
                  style="min-width: 60px"
                  type="number"
                  @input="getTotal"
                ></v-text-field>
              </td>
              <td
                v-show="selectFields[8].isTrue"
                class="text-left pa-0 pl-0 pr-1"
              >
                <v-text-field
                  class="pa-0 mt-2 centerTextField"
                  v-model="item.costPrice"
                  dense
                  hide-details
                  outlined
                  style="min-width: 140px; text-align: center"
                  type="number"
                  @input="setCostPrice(item)"
                ></v-text-field>
              </td>
              <td
                v-show="selectFields[9].isTrue"
                class="text-left pa-0 pl-0 pr-1"
              >
                <v-text-field
                  class="pa-0 mt-2 centerTextField"
                  v-model="item.total"
                  dense
                  hide-details
                  outlined
                  style="min-width: 120px"
                  type="number"
                  @input="getTotal"
                ></v-text-field>
              </td>
              <td
                v-show="selectFields[10].isTrue"
                class="text-left pa-0 pl-0 pr-1"
              >
                <v-text-field
                  class="pa-0 mt-2 centerTextField"
                  style="min-width: 60px"
                  v-model="item.price"
                  dense
                  hide-details
                  outlined
                  type="number"
                  @input="setPrice(item)"
                ></v-text-field>
              </td>
              <td
                v-show="selectFields[11].isTrue"
                class="text-left pa-0 pl-0 pr-1"
              >
                <v-text-field
                  class="pa-0 mt-2 centerTextField"
                  style="min-width: 60px"
                  v-model="item.priceAll"
                  dense
                  hide-details
                  outlined
                  type="number"
                  @input="getTotal"
                ></v-text-field>
              </td>
              <td
                v-show="selectFields[12].isTrue"
                class="text-left pa-0 pl-0 pr-1"
              >
                <v-text-field
                  class="pa-0 mt-2 centerTextField"
                  style="min-width: 60px"
                  v-model="item.priceRent"
                  dense
                  hide-details
                  outlined
                  type="number"
                  @input="setRent(item)"
                ></v-text-field>
              </td>
              <td
                v-show="selectFields[13].isTrue"
                class="text-left pa-0 pl-0 pr-1"
              >
                <v-text-field
                  class="pa-0 mt-2 centerTextField"
                  style="min-width: 60px"
                  v-model="item.rentDays"
                  dense
                  hide-details
                  outlined
                  type="number"
                  @input="setRentDays(item)"
                ></v-text-field>
              </td>
              <td
                v-show="selectFields[14].isTrue"
                class="text-left pa-0 pl-0 pr-1"
              >
                <v-text-field
                  class="pa-0 mt-2 centerTextField"
                  style="min-width: 60px"
                  v-model="item.days"
                  dense
                  hide-details
                  outlined
                  type="number"
                  @input="setRentDays(item)"
                ></v-text-field>
              </td>
              <td
                v-show="selectFields[15].isTrue"
                class="text-left pa-0 pl-0 pr-1"
              >
                <v-text-field
                  class="pa-0 mt-2 centerTextField"
                  style="min-width: 60px"
                  v-model="item.priceRentMonth"
                  dense
                  hide-details
                  outlined
                  type="number"
                  @input="getTotal"
                ></v-text-field>
              </td>
              <td
                v-show="selectFields[16].isTrue"
                class="text-left pa-0 pl-0 pr-1"
              >
                <v-text-field
                  class="pa-0 mt-2 centerTextField"
                  style="min-width: 60px"
                  v-model="item.percent"
                  dense
                  hide-details
                  outlined
                  type="number"
                  @input="setPrice(item)"
                >
                </v-text-field>
              </td>
              <td class="align-center">
                <v-icon @click="removeRow(item)">mdi-delete-forever</v-icon>
              </td>
            </tr>
            <v-btn icon @click="addRow" style="background-color: #419bec">
              <v-icon color="white">mdi-plus</v-icon>
            </v-btn>
            <tr>
              <td
                v-show="selectFields[0].isTrue"
                class="text-center green lighten-5"
                style="font-size: 18px"
              ></td>
              <td
                v-show="selectFields[1].isTrue"
                class="text-center green lighten-5"
                style="font-size: 18px"
              ></td>
              <td
                v-show="selectFields[2].isTrue"
                class="text-right"
                style="
                  font-size: 18px;
                  border: 4px solid #e8f5e9;
                  border-right: 4px solid white;
                  background-color: #e8f5e9;
                "
              >
                Итого:
              </td>
              <td
                v-show="selectFields[3].isTrue"
                class="text-center green lighten-5"
                style="font-size: 18px"
              ></td>
              <td
                v-show="selectFields[4].isTrue"
                class="text-center"
                style="
                  font-size: 18px;
                  border: 4px solid #e8f5e9;
                  border-right: 4px solid white;
                  background-color: #e8f5e9;
                "
              ></td>
              <td
                v-show="selectFields[5].isTrue"
                class="text-center pa-0 centerTextField"
                style="
                  font-size: 18px;
                  border: 4px solid #e8f5e9;
                  border-right: 4px solid white;
                  background-color: #e8f5e9;
                "
              >
                <v-text-field
                  class="pa-0"
                  :value="total.allWeight"
                  dense
                  hide-details
                  outlined
                  disabled
                ></v-text-field>
              </td>
              <td
                v-show="selectFields[6].isTrue"
                class="text-center pa-0 centerTextField"
                style="
                  font-size: 18px;
                  border: 4px solid #e8f5e9;
                  border-right: 4px solid white;
                  background-color: #e8f5e9;
                "
              >
                <v-text-field
                  class="pa-0"
                  :value="total.quantity"
                  dense
                  hide-details
                  outlined
                  disabled
                ></v-text-field>
              </td>
              <td
                v-show="selectFields[7].isTrue"
                class="text-center pa-0 centerTextField"
                style="
                  font-size: 18px;
                  border: 4px solid #e8f5e9;
                  border-right: 4px solid white;
                  background-color: #e8f5e9;
                "
              >
                <v-text-field
                  class="pa-0"
                  :value="total.s"
                  dense
                  hide-details
                  outlined
                  disabled
                ></v-text-field>
              </td>
              <td
                v-show="selectFields[8].isTrue"
                class="text-center pa-0 centerTextField"
                style="
                  font-size: 18px;
                  border: 4px solid #e8f5e9;
                  border-right: 4px solid white;
                  background-color: #e8f5e9;
                "
              ></td>
              <td
                v-show="selectFields[9].isTrue"
                class="text-center pa-0 centerTextField"
                style="
                  font-size: 18px;
                  border: 4px solid #e8f5e9;
                  border-right: 4px solid white;
                  background-color: #e8f5e9;
                "
              >
                <v-text-field
                  class="pa-0"
                  :value="total.totalXLS"
                  dense
                  hide-details
                  outlined
                  disabled
                ></v-text-field>
              </td>
              <td
                v-show="selectFields[10].isTrue"
                class="text-center"
                style="
                  font-size: 18px;
                  border: 4px solid #e8f5e9;
                  border-right: 4px solid white;
                  background-color: #e8f5e9;
                "
              ></td>
              <td
                v-show="selectFields[11].isTrue"
                class="text-center pa-0 centerTextField"
                style="
                  font-size: 18px;
                  border: 4px solid #e8f5e9;
                  border-right: 4px solid white;
                  background-color: #e8f5e9;
                "
              >
                <v-text-field
                  class="pa-0"
                  :value="total.priceAllXLS"
                  dense
                  hide-details
                  outlined
                  disabled
                ></v-text-field>
              </td>
              <td
                v-show="selectFields[12].isTrue"
                class="text-center"
                style="
                  font-size: 18px;
                  border: 4px solid #e8f5e9;
                  border-right: 4px solid white;
                  background-color: #e8f5e9;
                "
              ></td>
              <td
                v-show="selectFields[13].isTrue"
                class="text-center pa-0 centerTextField"
                style="
                  font-size: 18px;
                  border: 4px solid #e8f5e9;
                  border-right: 4px solid white;
                  background-color: #e8f5e9;
                "
              >
                <v-text-field
                  class="pa-0"
                  :value="total.rentDaysXLS"
                  dense
                  hide-details
                  outlined
                  disabled
                ></v-text-field>
              </td>
              <td
                class="text-center"
                v-show="selectFields[14].isTrue"
                style="
                  font-size: 18px;
                  border: 4px solid #e8f5e9;
                  border-right: 4px solid white;
                  background-color: #e8f5e9;
                "
              ></td>
              <td
                v-show="selectFields[15].isTrue"
                class="text-center pa-0 centerTextField"
                style="
                  font-size: 18px;
                  border: 4px solid #e8f5e9;
                  border-right: 4px solid white;
                  background-color: #e8f5e9;
                "
              >
                <v-text-field
                  class="pa-0"
                  :value="total.priceRentMonthXLS"
                  dense
                  hide-details
                  outlined
                  disabled
                ></v-text-field>
              </td>
              <td
                v-show="selectFields[16].isTrue"
                class="text-center green lighten-5"
                style="font-size: 18px"
              ></td>
              <td
                class="text-center green lighten-5"
                style="font-size: 18px"
              ></td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row class="mt-10 mb-10 justify-space-between">
      <v-col cols="7" class="mt-12">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th
                  class="text-center"
                  style="
                    border: 4px solid #e0e0e0;
                    border-right: 4px solid white;
                    background-color: #e0e0e0;
                  "
                >
                  Наименование
                </th>
                <th
                  class="text-center"
                  style="
                    border: 4px solid #e0e0e0;
                    border-right: 4px solid white;
                    background-color: #e0e0e0;
                  "
                >
                  ед.
                </th>
                <th
                  class="text-center"
                  style="
                    border: 4px solid #e0e0e0;
                    border-right: 4px solid white;
                    background-color: #e0e0e0;
                  "
                >
                  Кол-во
                </th>
                <th
                  class="text-center"
                  style="
                    border: 4px solid #e0e0e0;
                    border-right: 4px solid white;
                    background-color: #e0e0e0;
                  "
                >
                  Стоимость
                </th>
                <th class="text-center grey lighten-2">Итого:</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-left pa-0 pl-0 pr-1">
                  <v-text-field
                    class="pa-0"
                    value="Арендная плата"
                    dense
                    hide-details
                    outlined
                    disabled
                    style="min-width: 324px"
                  ></v-text-field>
                </td>
                <td class="text-left pa-0 pl-0 pr-1 centerTextField">
                  <v-text-field
                    class="pa-0"
                    value="сут"
                    dense
                    hide-details
                    outlined
                    disabled
                  ></v-text-field>
                </td>
                <td class="pa-0 pl-0 pr-1 centerTextField">
                  <v-text-field
                    v-model="rentDays"
                    dense
                    hide-details
                    outlined
                    type="number"
                    @input="getTotal"
                  ></v-text-field>
                </td>
                <td class="text-left pa-0 pl-0 pr-1 centerTextField">
                  <v-text-field
                    :value="total.rentDays.toFixed(2)"
                    dense
                    hide-details
                    outlined
                    type="number"
                    disabled
                  ></v-text-field>
                </td>
                <td class="text-left pa-0 pl-0 centerTextField">
                  <v-text-field
                    :value="rentTotalXLS"
                    dense
                    hide-details
                    outlined
                    disabled
                  ></v-text-field>
                </td>
              </tr>
              <tr>
                <td class="text-left pa-0 pl-0 pr-1">
                  <v-text-field
                    class="pa-0"
                    value="Обеспечительный взнос"
                    dense
                    hide-details
                    outlined
                    disabled
                    style="min-width: 324px"
                  ></v-text-field>
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td class="text-left pa-0 pl-0 centerTextField">
                  <v-text-field
                    v-model="priceRentMonth"
                    dense
                    hide-details
                    outlined
                    type="number"
                  ></v-text-field>
                </td>
              </tr>
              <tr>
                <td class="text-left pa-0 pl-0 pr-1">
                  <v-select
                    class="pa-0"
                    :items="[
                      'Транспортные расходы (в две стороны)',
                      'Транспортные расходы (в одну сторону)',
                    ]"
                    v-model="transport.name"
                    dense
                    hide-details
                    outlined
                    style="min-width: 324px"
                  ></v-select>
                </td>
                <td></td>
                <td class="text-left pa-0 pl-0 pr-1 centerTextField">
                  <v-text-field
                    v-model="transport.quantity"
                    dense
                    outlined
                    hide-details
                    type="number"
                    @input="getTotal"
                  ></v-text-field>
                </td>
                <td class="text-left pa-0 pl-0 pr-1 centerTextField">
                  <v-text-field
                    v-model="transport.price"
                    dense
                    outlined
                    hide-details
                    type="number"
                    @input="getTotal"
                  ></v-text-field>
                </td>
                <td class="text-left pa-0 pl-0 centerTextField">
                  <v-text-field
                    :value="transport.totalXLS"
                    dense
                    outlined
                    hide-details
                    disabled
                  ></v-text-field>
                </td>
              </tr>
              <tr>
                <td
                  class="text-left"
                  style="
                    font-size: 18px;
                    border: 4px solid #e8f5e9;
                    border-right: 4px solid white;
                    background-color: #e8f5e9;
                  "
                >
                  <b>Итого к оплате</b>
                </td>
                <td class="text-left green lighten-5"></td>
                <td class="text-left green lighten-5"></td>
                <td
                  class="text-left"
                  style="
                    font-size: 18px;
                    border: 4px solid #e8f5e9;
                    border-right: 4px solid white;
                    background-color: #e8f5e9;
                  "
                ></td>
                <td
                  class="text-left pa-0 centerTextField"
                  style="background-color: #e8f5e9"
                >
                  <v-text-field
                    class="pa-0"
                    :value="totalPayXLS"
                    dense
                    hide-details
                    outlined
                    disabled
                  ></v-text-field>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
      <v-col cols="3">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left green lighten-5">Площадь</th>
                <th class="text-left green lighten-5">
                  <v-text-field
                    style="width: 70px; background-color: white"
                    class="rounded-lg centerTextField"
                    v-model="square"
                    dense
                    outlined
                    hide-details
                    type="number"
                    @input="getTotal"
                  ></v-text-field>
                </th>
              </tr>
              <tr>
                <th
                  class="text-left"
                  style="
                    border: 4px solid #e0e0e0;
                    border-right: 4px solid white;
                    background-color: #e0e0e0;
                  "
                >
                  Наименование
                </th>
                <th class="text-center grey lighten-2">Кол-во</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Стойки</td>
                <td class="text-center">{{ materials.racks.toFixed(2) }}</td>
              </tr>
              <tr>
                <td>Треноги</td>
                <td class="text-center">{{ materials.tripods.toFixed(2) }}</td>
              </tr>
              <tr>
                <td>Унивилки</td>
                <td class="text-center">{{ materials.uniforks.toFixed(2) }}</td>
              </tr>
              <tr>
                <td>Балка м.п.</td>
                <td class="text-center">{{ materials.balka.toFixed(2) }}</td>
              </tr>
              <tr>
                <td>Фанера 18 (м3)</td>
                <td class="text-center">{{ materials.plywood.toFixed(2) }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
//import BX24 from "bx24-api";
import axios from "axios";

export default {
  name: "Table-temp",
  props: {
    url: String,
    table: Object,
    dealID: String,
    tables: Array,
    products: Array,
    typeEnum: Array,
  },
  data: () => ({
    settings: false,
    inputFile: "",
    file: "",
    selectFields: [
      {
        id: 1,
        title: "Показать 'N'",
        isTrue: false,
      },
      {
        id: 2,
        title: "Показать 'Артикул'",
        isTrue: false,
      },
      {
        id: 3,
        title: "Показать 'Наименование'",
        isTrue: true,
      },
      {
        id: 4,
        title: "Показать 'Площадь ед.'",
        isTrue: false,
      },
      {
        id: 5,
        title: "Показать 'Вес ед.'",
        isTrue: false,
      },
      {
        id: 6,
        title: "Показать 'Общий вес'",
        isTrue: true,
      },
      {
        id: 7,
        title: "Показать 'Кол-во, шт.'",
        isTrue: true,
      },
      {
        id: 8,
        title: "Показать 'S'",
        isTrue: true,
      },
      {
        id: 9,
        title: "Показать 'Себестоимость'",
        isTrue: false,
      },
      {
        id: 10,
        title: "Показать 'Итого'",
        isTrue: false,
      },
      {
        id: 11,
        title: "Показать 'Стоимость руб. (шт.)'",
        isTrue: true,
      },
      {
        id: 12,
        title: "Показать 'Стоимость руб.(общая)'",
        isTrue: true,
      },
      {
        id: 13,
        title: "Показать 'Стоимость аренды ед. в сутки, руб'",
        isTrue: true,
      },
      {
        id: 14,
        title: "Показать 'Аренда комплекта в сутки, руб.'",
        isTrue: true,
      },
      {
        id: 15,
        title: "Показать 'Кол-во дней'",
        isTrue: true,
      },
      {
        id: 16,
        title: "Показать 'Стоимость аренды в месяц, руб.'",
        isTrue: true,
      },
      {
        id: 17,
        title: "Показать '%'",
        isTrue: false,
      },
    ],
    nds: true,
    loading: false,
    materials: {
      racks: "",
      tripods: "",
      uniforks: "",
      balka: "",
      plywood: "",
    },
    square: 0,
    totalPay: 0.0,
    totalPayXLS: 0.0,
    rentTotal: 0.0,
    rentTotalXLS: 0.0,
    rentDays: 30,
    priceRentMonth: 0.0,
    priceRentMonthXLS: 0.0,
    entity: 600,
    transport: {
      name: "Транспортные расходы (в две стороны)",
      quantity: 0,
      price: 0,
      total: 0,
      totalXLS: 0,
    },
    tableData: [
      {
        id: 0,
        h: "",
        articl: "",
        title: "",
        productID: "",
        square: "",
        weight: "",
        allWeight: "",
        quantity: 1,
        s: "",
        costPrice: "",
        total: "",
        price: "",
        priceAll: "",
        priceRent: "",
        rentDays: "",
        days: 30,
        priceRentMonth: "",
        percent: 1.15,
      },
    ],
    total: {
      h: "",
      articl: "",
      title: "",
      square: 0,
      weight: 0,
      allWeight: 0,
      quantity: 0,
      quantityShields: 0,
      s: 0,
      costPrice: 0,
      total: 0,
      totalXLS: 0,
      price: 0,
      priceAll: 0,
      priceAllXLS: 0,
      priceRent: 0,
      rentDays: 0,
      rentDaysXLS: 0,
      days: 0,
      priceRentMonth: 0,
      priceRentMonthXLS: 0,
      percent: 0,
    },
  }),
  methods: {
    getProductTitle(id) {
      return this.products.filter((e) => e.id == id)[0];
    },
    async selectProducts(item) {
      try {
        const selectProducts = await this.getProductTitle(item.productID);
        item.weight = Number(selectProducts.weight);
        item.square = selectProducts.property388
          ? Number(selectProducts.property388.value)
          : 0;
        await this.setWeight(item);
        item.costPrice = Number(selectProducts.purchasingPrice).toFixed(2);
        item.price = Number(item.costPrice * item.percent).toFixed(2);
        item.priceRent = selectProducts.property376
          ? Number(selectProducts.property376.value.split("|")[0]).toFixed(2)
          : 0;
        item.articl = selectProducts.property380
          ? selectProducts.property380.value
          : "";
        item.h = selectProducts.property374
          ? this.typeEnum.filter(
              (e) => e.id == selectProducts.property374.value
            )[0].value
          : "";
        item.title = selectProducts.name;
        await this.getTotal();
      } catch (e) {
        console.log(e);
      }
    },
    async getProductToDeal() {
      try {
        console.log("get products to deal");
        const rowsDatas = this.table.value.split("DEAL:")[0].split("ROWEND/");
        const dealDatas = this.table.value.split("DEAL:")[1].split(";");

        this.rentDays = dealDatas[0];
        this.totalPay = dealDatas[1];
        this.rentTotal = dealDatas[2];
        this.square = dealDatas[3];
        this.priceRentMonth = dealDatas[4];
        this.entity = dealDatas[5];
        this.transport = {
          name: dealDatas[6]
            ? dealDatas[6]
            : "Транспортные расходы (в две стороны)",
          quantity: dealDatas[7],
          total: dealDatas[8],
          price: dealDatas[9],
        };
        this.materials = {
          racks: dealDatas[10],
          tripods: dealDatas[11],
          uniforks: dealDatas[12],
          balka: dealDatas[13],
          plywood: dealDatas[14],
        };
        this.total = {
          h: "",
          articl: "",
          title: "",
          square: 0,
          weight: 0,
          allWeight: 0,
          quantity: 0,
          quantityShields: 0,
          s: 0,
          costPrice: 0,
          total: 0,
          price: 0,
          rentDays: dealDatas[15],
          priceAll: dealDatas[16],
          priceRent: dealDatas[15],
          days: 0,
          priceRentMonth: dealDatas[17],
          percent: 0,
        };
        this.nds =
          dealDatas[18] == ", НДС 20%."
            ? true
            : dealDatas[18] == "без НДС"
            ? false
            : true;

        this.tableData = [];
        for (const row of rowsDatas) {
          if (row) {
            const rowDatas = row.split(";");
            console.log(rowDatas);

            const selectProducts = await this.getProductTitle(rowDatas[3]);

            const otherField = [
              Number(rowDatas[0]),
              Number(rowDatas[1]),
              Number(rowDatas[2]),
            ];
            console.log({ selectProducts });
            this.tableData.push({
              id: rowDatas[3],
              h: selectProducts
                ? this.typeEnum.filter(
                    (e) => e.id == selectProducts.property374.value
                  )[0].value
                : "",
              articl: selectProducts ? selectProducts.property380.value : "",
              title: rowDatas[4],
              productID: this.products.filter((e) => e.name == rowDatas[4])[0]
                .id,
              square: Number(otherField[0]),
              weight: Number(otherField[1]).toFixed(2),
              allWeight: (Number(otherField[1]) * Number(rowDatas[7])).toFixed(
                2
              ),
              quantity: Number(rowDatas[7]),
              s: (Number(otherField[0]) * Number(rowDatas[7])).toFixed(2),
              costPrice: (Number(rowDatas[10]) / Number(otherField[2])).toFixed(
                2
              ),
              total: (
                Number(rowDatas[7]) *
                (Number(rowDatas[10]) / Number(otherField[2]))
              ).toFixed(2),
              price: Number(rowDatas[10]).toFixed(2),
              priceAll: (Number(rowDatas[7]) * Number(rowDatas[10])).toFixed(2),
              priceRent: Number(rowDatas[9]).toFixed(2),
              rentDays: (Number(rowDatas[9]) * Number(rowDatas[7])).toFixed(2),
              days: Number(rowDatas[8]),
              priceRentMonth: (
                Number(rowDatas[9]) *
                Number(rowDatas[7]) *
                Number(rowDatas[8])
              ).toFixed(2),
              percent: Number(otherField[2]),
            });
          }
        }
        this.getTotal();
      } catch (e) {
        console.log({ e });
      }
    },
    async addToDeal() {
      try {
        this.loading = true;
        console.log("addToDeal");
        const otherFields = [];
        let table = "";
        const params = {
          id: this.dealID,
          rows: [],
        };
        for (const item of this.tableData) {
          const otherField = ``;
          const selectProducts = await this.getProductTitle(item.productID);

          table += `${item.square};${item.weight};${item.percent};${
            selectProducts.id
          };${selectProducts.name};${item.priceRentMonth};${Number(
            item.rentDays
          ).toFixed(2)};${item.quantity};${item.days};${Number(
            item.priceRent
          ).toFixed(2)};${item.price};ROWEND/`;
          console.log({ selectProducts });
          params.rows.push({
            PRODUCT_ID: selectProducts.id,
            PRODUCT_NAME: selectProducts.name, //название (1 столб)
            DISCOUNT_SUM: item.priceRentMonth, //Стоимость аренды в месяц, руб(8 столб)
            MEASURE_NAME: Number(item.rentDays).toFixed(2), //Аренда комплекта в сутки, руб.(6 столб)
            QUANTITY: item.quantity, //кол-во(2 столб)
            SORT: item.days, //Кол-во дней(7 столб)
            MEASURE_CODE: Number(item.priceRent).toFixed(2), // Стоимость аренды ед. в сутки, руб.(5 столб)
            PRICE: item.price, //Стоимость. руб. (шт)(3 столб)
          });
          otherFields.push(otherField);
        }
        console.log(params.rows, "rows");
        //заполняем сделку нужными полями
        const tables = this.tables
          .filter((e) => e.id != this.table.id)
          .map((e) => e.value);
        tables.push(
          `${table}DEAL:${this.rentDays ? this.rentDays : 0};${
            this.totalPay ? Number(this.totalPay).toFixed(2) : 0.0
          };${this.rentTotal ? Number(this.rentTotal).toFixed(2) : 0.0};${
            this.square ? this.square : 0
          };${
            this.priceRentMonth ? Number(this.priceRentMonth).toFixed(2) : 0.0
          };${this.entity ? this.entity : 0};${
            this.transport.name
              ? this.transport.name
              : "Транспортные расходы (в две стороны)"
          };${this.transport.quantity ? this.transport.quantity : 0};${
            this.transport.total ? Number(this.transport.total).toFixed(2) : 0.0
          };${
            this.transport.price ? Number(this.transport.price).toFixed(2) : 0.0
          };${this.materials.racks ? this.materials.racks : 0};${
            this.materials.tripods ? this.materials.tripods : 0
          };${this.materials.uniforks ? this.materials.uniforks : 0};${
            this.materials.balka ? this.materials.balka : 0
          };${this.materials.plywood ? this.materials.plywood : 0};${
            this.total.rentDays ? Number(this.total.rentDays).toFixed(2) : 0.0
          };${
            this.total.priceAll ? Number(this.total.priceAll).toFixed(2) : 0.0
          };${
            this.total.priceRentMonth
              ? Number(this.total.priceRentMonth).toFixed(2)
              : 0.0
          };${this.nds ? ", НДС 20%." : "без НДС"};`
        );
        const paramsAddDeal = {
          id: this.dealID,
          fields: {
            // UF_CRM_1692958761: this.rentDays, //(app)Арендная плата_кол-во
            // UF_CRM_1692958963: Number(this.totalPay).toFixed(2), //(app)Итого к оплате
            // UF_CRM_1692958807: Number(this.rentTotal).toFixed(2), //(app)Арендная плата_итого
            // UF_CRM_1692958873: this.square, //(app)площадь
            // UF_CRM_1702626925: this.transport.name,
            // UF_CRM_1692958902: this.transport.quantity, //(app)Транспортные расходы (в две стороны)_кол-во
            // UF_CRM_1692958915: Number(this.transport.total).toFixed(2), //(app)Транспортные расходы (в две стороны)_итого
            // UF_CRM_1692975124: Number(this.transport.price).toFixed(2), //(app)Транспортные расходы (в две стороны)_цена
            // UF_CRM_1694782081: Number(this.priceRentMonth).toFixed(2), //Обеспечительный взнос 1694782081
            // UF_CRM_1692959922: this.materials.racks, //(app)Стойки
            // UF_CRM_1692959947: this.materials.tripods, //(app)Треноги
            // UF_CRM_1692959969: this.materials.uniforks, //(app) Унивилки
            // UF_CRM_1692959991: this.materials.balka, //(app) Балка м.п.
            // UF_CRM_1692960009: this.materials.plywood, //(app)Фанера 18 (м3)
            // UF_CRM_1692958775: Number(this.total.rentDays).toFixed(2), //(app)Арендная плата_цена
            // UF_CRM_1693227641: '', //(app) Итого Стоимость. руб. (Общая)
            // UF_CRM_1693227675: '', //(app)Итого Аренда комплекта в сутки, руб.
            // UF_CRM_1693227698: '', //(app)Итого Стоимость аренды в месяц, руб
            // UF_CRM_1693562840: otherFields, //площадь, S, Вес, процент
            // UF_CRM_1693565687: '',
            // UF_CRM_1695917371: '',
            UF_CRM_1705579107440: tables,
          },
          params: { REGISTER_SONET_EVENT: "Y" },
        };
        console.log({ paramsAddDeal });
        const dealAdd = await axios.post(
          this.url + "crm.deal.update",
          paramsAddDeal
        );
        console.log({ dealAdd });
        await axios.post(this.url + "crm.deal.productrows.set", params);

        //создаем КП
        await axios.post(this.url + "bizproc.workflow.start", {
          TEMPLATE_ID: "204",
          DOCUMENT_ID: ["crm", "CCrmDocumentDeal", this.dealID],
          PARAMETERS: {
            title: `Таблица ${Number(this.table.id) + 1}`,
            rentDays: this.rentDays,
            totalPay: Number(this.totalPay).toFixed(2),
            rentTotal: Number(this.rentTotal).toFixed(2),
            square: this.square,
            transportname: this.transport.name,
            transportquantity: this.transport.quantity,
            transporttotal: Number(this.transport.total).toFixed(2),
            transportprice: Number(this.transport.price).toFixed(2),
            priceRentMonth: Number(this.priceRentMonth).toFixed(2),
            materialsracks: this.materials.racks,
            materialstripods: this.materials.tripods,
            materialsuniforks: this.materials.uniforks,
            materialsbalka: this.materials.balka,
            materialsplywood: this.materials.plywood,
            totalrentDays: Number(this.total.rentDays).toFixed(2),
            totalpriceAll: Number(this.total.priceAll).toFixed(2),
            totalpriceRentMonth: Number(this.total.priceRentMonth).toFixed(2),
            otherFields: otherFields,
            entity: this.entity,
            nds: this.nds ? ", НДС 20%." : "без НДС",
          },
        });
        location.reload();
        //this.loading = false;
      } catch (e) {
        console.log(e);
      }
    },
    async removeRow(item) {
      if (this.tableData.length > 1) {
        const index = this.tableData.findIndex((e) => e.id == item.id);
        this.tableData.splice(index, 1);
      }
      await this.getTotal();
    },
    addRow() {
      this.tableData.push({
        id: this.tableData[this.tableData.length - 1].id + 1,
        h: "",
        articl: "",
        title: "",
        productID: "",
        square: "",
        weight: "",
        allWeight: "",
        quantity: 1,
        s: "",
        costPrice: "",
        total: "",
        price: "",
        priceAll: "",
        priceRent: "",
        rentDays: "",
        days: 30,
        priceRentMonth: "",
        percent: 1.15,
      });
      console.log(this.tableData, "table");
    },
    async getTotal() {
      this.total = {
        h: "",
        articl: "",
        title: "",
        square: 0,
        weight: 0,
        allWeight: 0,
        quantity: 0,
        quantityShields: 0,
        s: 0,
        costPrice: 0,
        total: 0,
        totalXLS: "",
        price: 0,
        priceAll: 0,
        priceAllXLS: "",
        priceRent: 0,
        rentDays: 0,
        rentDaysXLS: "",
        days: 0,
        priceRentMonth: 0,
        priceRentMonthXLS: "",
        percent: 0,
      };
      for (const item of this.tableData) {
        if (item.square) {
          item.s = (item.square * item.quantity).toFixed(2);
          item.priceRent = (
            Number(item.square) * Number((this.entity / 30).toFixed(2))
          ).toFixed(2);
        }
        //setPrice
        item.priceAll = (item.quantity * item.price).toFixed(2);
        item.price = (item.costPrice * item.percent).toFixed(2);
        //setCostPrice
        item.total = (item.quantity * item.costPrice).toFixed(2);
        item.price = (item.costPrice * item.percent).toFixed(2);
        //setWeight
        item.allWeight = (item.weight * item.quantity).toFixed(2);
        //setQuantity
        item.total = (item.quantity * item.costPrice).toFixed(2);
        item.priceAll = (item.quantity * item.price).toFixed(2);
        item.rentDays = (item.quantity * item.priceRent).toFixed(2);
        item.priceRentMonth = (item.rentDays * item.days).toFixed(2);
        //setRent
        item.rentDays = (item.quantity * item.priceRent).toFixed(2);
        item.priceRentMonth = (item.rentDays * item.days).toFixed(2);
        //total
        this.total.square += Number(item.square);
        this.total.weight += Number(item.weight);
        this.total.allWeight += Number(item.allWeight);
        this.total.quantity += Number(item.quantity);
        this.total.s += Number(item.s);
        this.total.costPrice += Number(item.costPrice);
        this.total.total += Number(item.total);
        this.total.price += Number(item.price);
        this.total.priceAll += Number(item.priceAll);
        this.total.priceRent += Number(item.priceRent);
        this.total.rentDays += Number(item.rentDays);
        this.total.days += Number(item.days);
        this.total.priceRentMonth += Number(item.priceRentMonth);
        this.total.percent += Number(item.percent);
        if (
          item.title.toLowerCase().includes("щит") ||
          item.title.toLowerCase().includes("угол")
        ) {
          console.log({ item });
          this.total.quantityShields += Number(item.quantity);
        }
      }
      this.rentTotal = this.total.rentDays * this.rentDays;
      this.transport.total = (
        this.transport.quantity * this.transport.price
      ).toFixed(2);

      this.priceRentMonth = this.rentTotal.toFixed(2);

      this.totalPay =
        Number(this.transport.total) +
        Number(this.priceRentMonth) +
        Number(this.rentTotal);
      this.materials.racks = this.square / 1.6;
      this.materials.tripods = this.square / 2.5;
      this.materials.uniforks = this.materials.racks;
      this.materials.balka = this.square * 3;
      this.materials.plywood = this.square * 0.018;

      this.total.totalXLS = new Intl.NumberFormat("ru-RU", {
        minimumFractionDigits: 2,
      }).format(Number(this.total.total));
      this.total.priceAllXLS = new Intl.NumberFormat("ru-RU", {
        minimumFractionDigits: 2,
      }).format(Number(this.total.priceAll));
      this.total.priceRentMonthXLS = new Intl.NumberFormat("ru-RU", {
        minimumFractionDigits: 2,
      }).format(Number(this.total.priceRentMonth));
      this.total.allWeight = this.total.allWeight.toFixed(2);
      this.total.rentDaysXLS = new Intl.NumberFormat("ru-RU", {
        minimumFractionDigits: 2,
      }).format(Number(this.total.rentDays));
      this.totalPayXLS = new Intl.NumberFormat("ru-RU", {
        minimumFractionDigits: 2,
      }).format(Number(this.totalPay));
      console.log(this.totalPay);
      console.log(this.totalPayXLS);

      this.transport.totalXLS = new Intl.NumberFormat("ru-RU", {
        minimumFractionDigits: 2,
      }).format(Number(this.transport.total));
      this.rentTotalXLS = new Intl.NumberFormat("ru-RU", {
        minimumFractionDigits: 2,
      }).format(Number(this.rentTotal));
    },
    async setPrice(item) {
      item.priceAll = (item.quantity * item.price).toFixed(2);
      item.price = (item.costPrice * item.percent).toFixed(2);
      await this.getTotal();
    },
    async setCostPrice(item) {
      item.total = (item.quantity * item.costPrice).toFixed(2);
      item.price = (item.costPrice * item.percent).toFixed(2);
      await this.getTotal();
    },
    async setWeight(item) {
      item.allWeight = (item.weight * item.quantity).toFixed(2);
      await this.getTotal();
    },
    async setQuantity(item) {
      item.allWeight = (item.weight * item.quantity).toFixed(2);
      item.total = (item.quantity * item.costPrice).toFixed(2);
      item.priceAll = (item.quantity * item.price).toFixed(2);
      item.rentDays = (item.quantity * item.priceRent).toFixed(2);
      item.priceRentMonth = (item.rentDays * item.days).toFixed(2);
      await this.getTotal();
    },
    async setRent(item) {
      item.rentDays = (item.quantity * item.priceRent).toFixed(2);
      item.priceRentMonth = (item.rentDays * item.days).toFixed(2);
      await this.getTotal();
    },
    async setRentDays(item) {
      item.rentDays = (item.quantity * item.priceRent).toFixed(2);
      item.priceRentMonth = (item.rentDays * item.days).toFixed(2);
      await this.getTotal();
    },
    processFileContent(data) {
      this.file = data.split("\n");
      console.log(this.file);
      this.setItems();
    },
    setItems() {
      this.type = this.file[0].split("\r")[0];
      this.file.splice(0, 1);
      console.log(this.file);
      for (const elem of this.file) {
        if (elem) {
          //TODO раскидать по полям
          console.log({ elem });
        }
      }
    },
  },
  async mounted() {
    try {
      if (this.table.value) {
        this.loading = true;
        await this.getProductToDeal();
        this.loading = false;
      }
    } catch (e) {
      console.log(e);
    }
  },
};
</script>
<style scoped></style>
